var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWineGlassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42879 9.4817V7.27055C3.964 7.09903 2.4946 7.12421 3.02981 7.29573V9.4817L2.0192 9.80194C1.97041 9.8174 1.93726 9.86269 1.93726 9.91387C1.93726 9.96134 1.97574 9.99982 2.02321 9.99982H4.43912C4.48659 9.99982 4.52507 9.96134 4.52507 9.91387C4.52507 9.8627 4.4919 9.81743 4.44311 9.80202L3.42879 9.4817Z",
    fill: "#9CC43B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37118 0H1.02594L0.762939 1.97924H1.40329C2.03794 1.93905 2.67492 2.00095 3.29004 2.16261L3.63309 2.27722C4.08422 2.44371 4.55908 2.53658 5.03957 2.55228C5.26579 2.55552 5.49178 2.53632 5.71423 2.49497L5.37118 0Z",
    fill: "#9CC43B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95442 4.56721C5.95442 6.07682 4.73341 7.3006 3.22721 7.3006C1.72101 7.3006 0.5 6.07682 0.5 4.56721V4.20047L0.763001 1.97917H1.40335C2.038 1.93898 2.67498 2.00088 3.2901 2.16254L3.63315 2.27715C4.08428 2.44365 4.55914 2.53651 5.03963 2.55221C5.26585 2.55545 5.49184 2.53626 5.71429 2.4949L5.93155 4.23485L5.95442 4.56721Z",
    fill: "#CC4B37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineGlassIcon);
export default __webpack_public_path__ + "static/media/WineGlassIcon.652efe2f4b7c647d93c6b1206b51b6a5.svg";
export { ForwardRef as ReactComponent };